import {
  useEasyServiceGetApiEasyCheckLoginState,
  useHealthServicePostApiHealthKeepalive,
} from "../../openapi/api/queries/queries";

import { useEffect } from "react";

import { useNavigate } from "@tanstack/react-router";

type KeepAliveData = {
  isNewSession: boolean;
};

export function KeepAliveInterval({
  isLoggedIntoEasy,
  setIsLoggedIntoEasy,
}: {
  isLoggedIntoEasy: boolean;
  setIsLoggedIntoEasy: (value: boolean) => void;
}): void {
  const { mutate: keepAlive } = useHealthServicePostApiHealthKeepalive();

  const navigate = useNavigate();
  const { refetch } = useEasyServiceGetApiEasyCheckLoginState();

  useEffect(() => {
    const interval = setInterval(async () => {
      const { isSuccess } = await refetch();
      if (isSuccess !== isLoggedIntoEasy) {
        location.reload();
      }
      keepAlive(
        { requestBody: { isLoggedIn: isSuccess } },
        {
          onSuccess: (data) => {
            const { isNewSession } = data as KeepAliveData;
            if (isNewSession) {
              setIsLoggedIntoEasy(false);
              location.reload();
            }
          },
        },
      );
    }, 300000);

    return () => clearInterval(interval);
  }, [keepAlive, navigate, refetch, setIsLoggedIntoEasy, isLoggedIntoEasy]);
}
